import { render, staticRenderFns } from "./task.vue?vue&type=template&id=74840676&scoped=true&"
import script from "./task.vue?vue&type=script&lang=js&"
export * from "./task.vue?vue&type=script&lang=js&"
import style0 from "./task.vue?vue&type=style&index=0&lang=css&"
import style1 from "./task.vue?vue&type=style&index=1&id=74840676&scoped=true&lang=css&"
import style2 from "./task.vue?vue&type=style&index=2&id=74840676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74840676",
  null
  
)

export default component.exports